import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Button } from "@/shared/ui";
import { PROFILE_PAGE_ROUTE } from "@/shared/utils";

export default function AccessDeniedPage() {
  const { t } = useTranslation("AccessDeniedPage");
  const navigate = useNavigate();

  return (
    <>
      <title>{t("title")}</title>
      <meta name="description" content={t("description")} />
      <section className="p-7 rounded-[28px] surface-base-fill h-full overflow-hidden">
        <div className="flex flex-col items-center justify-center min-h-[60vh]">
          <h1 className="text-display-xs content-base-primary mb-4">{t("title")}</h1>
          <p className="text-body-regular-md content-base-secondary mb-8 text-center max-w-md">
            {t("description")}
          </p>
          <Button variant="primary" onClick={() => navigate(PROFILE_PAGE_ROUTE)}>
            {t("button")}
          </Button>
        </div>
      </section>
    </>
  );
}

